import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import type { ProviderOperationsAction } from "libs/apiClient";
import Modal from "ui-kit/src/Modal";
import type { ProviderOperationsBulkPlan } from "./getProviderOperationsBulkPlan";
import { PROVIDER_OPERATIONS_ACTION_LABEL_KEYS } from "./providerOperationsActionLabelKeys";

type ProviderOperationsBulkConfirmModalProps = {
	action: ProviderOperationsAction;
	plan: ProviderOperationsBulkPlan;
	isActionRunning: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export function ProviderOperationsBulkConfirmModal({
	action,
	plan,
	isActionRunning,
	onConfirm,
	onCancel,
}: ProviderOperationsBulkConfirmModalProps) {
	return (
		<Modal show title={_("providerOperations.bulk.confirm.title" as keyof Keys)} size="sm" onClose={onCancel}>
			<div className="provider-operations-bulk-confirm">
				<p>
					{_("providerOperations.bulk.confirm.action" as keyof Keys)}:{" "}
					<strong>{_(PROVIDER_OPERATIONS_ACTION_LABEL_KEYS[action] as keyof Keys)}</strong>
				</p>
				<p className="provider-operations-muted">
					{_("providerOperations.bulk.providerRequestIds" as keyof Keys)}:{" "}
					{plan.rowsToRun.map((row) => row.providerRequestId ?? row.id).join(", ")}
				</p>
				<div className="provider-operations-actions">
					<button
						className="admin-button admin-button--primary admin-button--xs"
						type="button"
						disabled={plan.rowsToRun.length === 0 || isActionRunning}
						onClick={onConfirm}
					>
						{_("providerOperations.bulk.confirm.run" as keyof Keys)}
					</button>
					<button className="admin-button admin-button--secondary admin-button--xs" type="button" onClick={onCancel}>
						{_("btn.cancel")}
					</button>
				</div>
			</div>
		</Modal>
	);
}
